export const PATH_CART_PAYMENT_METHODS = '/cart/confirm/:token';
export const PATH_CART_SIGNUP = '/cart/signup';
export const PATH_CART_SIGNUP_CHANGE_ACCOUNT = '/cart/signup/change-account';
export const PATH_CART_LOGIN = '/cart/login';
export const PATH_CART_LOGIN_CHANGE_ACCOUNT = '/cart/login/change-account';
export const PATH_CART_ADD = '/cart/add/:productId';
export const PATH_CART_THANK_YOU = '/cart/thank-you/:token';
export const PATH_CART_SAVE_PAYMENT = '/cart/save-payment';
